"use strict";
exports.__esModule = true;
exports.Application = void 0;
require("core-js/stable/dom-collections/for-each");
var ease_component_1 = require("ease-component");
var menu_1 = require("./menu");
var swiper_1 = require("./swiper");
var image_1 = require("./modals/image");
var media_1 = require("./modals/media");
var form_1 = require("./form");
var validator_1 = require("./form/validator");
var submit_handler_1 = require("./form/submit-handler");
var form_modal_1 = require("./form-modal");
var scroll_to_1 = require("./scroll.to");
var toggler_1 = require("./toggler");
var static_assets_1 = require("./static.assets");
var Application = /** @class */ (function () {
    function Application() {
    }
    Application.prototype.run = function () {
        this.initMenu();
        this.initSlider();
        this.initModalImage();
        this.initModalMedia();
        this.initFormModal();
        this.initScrollTo();
        this.initToggler();
        this.initStaticAssets();
    };
    Application.prototype.initMenu = function () {
        new menu_1.Menu({
            collapseContainer: '.navbar-collapse-menu',
            togglerSelector: '.navbar-toggler-menu',
            isSubmenuCollapsible: true,
            expandedMenuItemSelector: '.mobile-menu__collapse-trigger',
            expandedMenuContainerSelector: '.mobile-menu__level1',
            submenuContainerSelector: '.mobile-menu__level2',
            closeElementSelector: '.navbar-collapse-menu-close'
        }).run();
    };
    Application.prototype.initSlider = function () {
        var projectsSlider = document.querySelector('.projects-slider__instance');
        if (projectsSlider !== null) {
            new swiper_1.SwiperSlider({
                container: projectsSlider,
                options: {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    slidesPerView: 2,
                    navigation: {
                        nextEl: '.projects-slider__button-next',
                        prevEl: '.projects-slider__button-prev',
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 10
                        },
                        410: {
                            slidesPerView: 1
                        },
                        767: {
                            slidesPerView: 2,
                            spaceBetween: 15
                        },
                        991: {
                            slidesPerView: 2,
                            spaceBetween: 20
                        },
                        1199: {
                            slidesPerView: 2,
                            spaceBetween: 30
                        },
                        1330: {
                            slidesPerView: 2,
                            spaceBetween: 65
                        }
                    }
                }
            }).run();
        }
    };
    Application.prototype.initModalImage = function () {
        new image_1.ModalImage({
            elementsSelector: '.fancybox__image',
            options: {
                smallBtn: true
            }
        }).run();
        new image_1.ModalImage({
            elementsSelector: '.fancybox__slider-image',
            elementsIngoreSelector: '.swiper-slide-duplicate',
            options: {
                smallBtn: true
            }
        }).run();
    };
    Application.prototype.initModalMedia = function () {
        new media_1.ModalMedia({
            elementsSelector: '.fancybox__media'
        }).run();
    };
    Application.prototype.initFormModal = function () {
        var items = document.querySelectorAll('.modal-form__opener');
        items.forEach(function (item) {
            var element = item;
            var options = {};
            if (element.dataset.fancyboxWrap) {
                options.wrapCSS = element.dataset.fancyboxWrap;
            }
            options.afterShow = function (instance, current) {
                var container = document.querySelector('.modal__form-container');
                if (container !== null) {
                    var formElement = container.querySelector('form');
                    if (formElement !== null) {
                        var form = new form_1.Form({
                            form: formElement
                        });
                        var validator = new validator_1.FormValidator({
                            form: form,
                            options: {
                                submitHandler: submit_handler_1.FormSubmitHandler.submit
                            }
                        });
                        form.setValidator(validator);
                        validator.validate();
                    }
                }
            };
            new form_modal_1.FormModal({
                element: element,
                options: options
            }).run();
        });
    };
    Application.prototype.initScrollTo = function () {
        var items = document.querySelectorAll('.scroll__btn');
        items.forEach(function (item) {
            var element = item;
            if (!element.dataset.scrollHref) {
                return;
            }
            var scrollTarget = document.querySelector(element.dataset.scrollHref);
            if (scrollTarget === null) {
                return;
            }
            new scroll_to_1.ScrollTo({
                triggerElement: item,
                destination: scrollTarget,
                ease: ease_component_1.inOutSine,
                scrollDuration: element.dataset.scrollDuration ? parseInt(element.dataset.scrollDuration) : 1000
            }).run();
        });
    };
    Application.prototype.initToggler = function () {
        var items = document.querySelectorAll('.toggler__btn');
        items.forEach(function (item) {
            var element = item;
            if (!element.dataset.target) {
                return;
            }
            var target = document.querySelector(element.dataset.target);
            if (target === null) {
                return;
            }
            new toggler_1.Toggler({
                element: item,
                target: target
            }).run();
        });
    };
    Application.prototype.initStaticAssets = function () {
        new static_assets_1.StaticAssets().run();
    };
    return Application;
}());
exports.Application = Application;
